// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".empty-page{display:flex;flex-direction:column;align-items:center;gap:40px;margin:220px auto auto}.empty-page__image{padding:12px;background:#d8d5dd;border-radius:50%}@media(max-width: 576px){.empty-page{padding:0 30px;text-align:center;gap:20px}}", ""]);
// Exports
module.exports = exports;
